import SimulateMatchDialog from './SimulateMatchDialog'

export default SimulateMatchDialog
